import { Immutable } from "immer";
import React from "react";
import { Key } from "ts-key-enum";

import { useAppSelector } from "../../../store/reducers";
import { defaultState } from "../defaults";

type IProps = Immutable<{
    onLoadMore: () => void;
}>;

const onKeyPressHandler = (
    event: React.KeyboardEvent,
    onLoadMore: () => void,
): void => {
    if (!onLoadMore) {
        return;
    }
    if (event.key === Key.Enter) {
        onLoadMore();
    }
};

export const LoadMoreButton = (props: IProps): React.ReactNode => {
    const hasMore = useAppSelector(
        (state) => (state.reviews || defaultState).ui.hasMore,
    );

    if (!hasMore) {
        return null;
    }
    return (
        <div
            role="button"
            tabIndex={0}
            className="customer-review__footer"
            onClick={props.onLoadMore}
            onKeyPress={(event) => onKeyPressHandler(event, props.onLoadMore)}
        >
            Load More Reviews
            <span className="customer-review__footer__icon"></span>
        </div>
    );
};
